import React , {useEffect,  useState } from 'react';
import Logo from '../assets/logo.png'
import email from '../assets/email.svg'
import lock from '../assets/lock.svg'
import voltar from '../assets/voltar.svg'
import { useFormik } from 'formik';
import api from '../config/api'
import PassShowHide from '../components/passShowHide'
import { useDispatch, useSelector } from 'react-redux'
import { actions } from '../store/reducers/userReducer'


function validate(values) {
  const errors = {};

  if (!values.email) {
    errors.email = 'Campo obrigatório';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Digite um email válido';
  }

  if (!values.password) {
    errors.password = 'Campo obrigatório';
  } else if (values.password.length < 6) {
    errors.password = 'Precisa ter 6 caracteres ou mais';
  }

  return errors;
};

export default function Login({ history }) {
  const dispatch = useDispatch()
  const state = useSelector(state=>state.userReducer)

  const [typeError,setType] = useState(false)

   useEffect(() => {
    const token = localStorage.getItem('token')
    if (!state.logged && token) {
      
        api.post('/authenticate', '', {
          headers: {
            token: token
          }
        })
        .then((response) => {
          response.data.logged = true
          dispatch(actions.setIfosUser(response.data))
          history.push('/')
        })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.message === "token invalid") {
              } else if (error.response.data.message === "token not declared") {
              } else if (error.response.data.message === "error in athentication") {
              }
          }
        })
      
    } else {
    }
  }, []) // eslint-disable-line

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validate,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: async values => {
      api.post('/login', values)
      .then(function (response) {
          localStorage.setItem('token',response.data.token)
          history.push('/')
      })
      .catch(function (error) {
        if(error.response){
          if(error.response.data.message === "user not exists"){
            setType('O email fornecido não posui uma conta')
            formik.setFieldValue('email','')
          } else if(error.response.data.message === "error in requisition of db") {
            setType('Falha interna no servidor tente novamente mais tarde')
            formik.setFieldValue('email','')
            formik.setFieldValue('password','')
          } else if(error.response.data.message === "invalid password") {
            setType('A senha fornecida não confere')
            formik.setFieldValue('password','')
          }
        } else {
          setType('Falha interna no servidor tente novamente mais tarde')
          formik.setFieldValue('email','')
          formik.setFieldValue('password','')
        }
      });
    },
  });

  function handleRegister(event) {
    event.preventDefault();
    history.push('signup')
  }

  function handleForgot(event) {
    event.preventDefault();
    history.push('forgotpassword')
  }

  function handleBack(event) {
    event.preventDefault();
    history.push('/')
  }
  return (
    <>
      <div className='container login d-flex flex-column align-items-center bg-light'>
        <a className="navbar-brand pb-2 socialLogos voltar" onClick={event => handleBack(event)} href='.' >
          <img className="mb-3" src={voltar} alt="logo" width="24" height="24" />
        </a>

        <img className="mb-4" src={Logo} alt="logo" width="90" height="90" />
        
        
        

        <form className='form' onSubmit={formik.handleSubmit}>

        
          <div className="input-group input-group mb-4 mr-sm-2">
            {typeError ? <small id="emailHelp" className="infosLogin">{typeError}</small> : null}

            <div className="input-group-prepend">
              <div className={formik.errors.email ? "input-group-text borderRed" : "input-group-text"}>
                <img className="" src={email} alt="logo" width="18" height="18" />
              </div>
            </div>
            <input
              className={formik.errors.email ? "form-control borderRed" : "form-control"}
              id="email"
              name="email"
              placeholder='Email'
              onChange={formik.handleChange}
              value={formik.values.email}
            />
            {formik.errors.email ? <div className='invalid'>{formik.errors.email}</div> : null}
          </div>

          <div className="form-group">
            <div className="input-group input-group mb-4 mr-sm-2">
              <div className="input-group-prepend">
                <div className={formik.errors.password ? "input-group-text borderRed" : "input-group-text"}>
                  <img className="" src={lock} alt="logo" width="18" height="18" />
                </div>
              </div>
              <PassShowHide
                className={formik.errors.password ? "form-control borderRed" : "form-control"}
                id="password"
                name="password"
                placeholder='Senha'
                onChange={formik.handleChange}
                value={formik.values.password} />
              {formik.errors.password ? <div className='invalid'>{formik.errors.password}</div> : null}
            </div>
            <a className='text-info' onClick={event => handleForgot(event)} href='.' >Esqueci minha senha</a>
          </div>

          <button className="btn btn-outline-dark btn-block w-100 mb-2" type="submit">Entrar</button>
          <a className='text-info' onClick={event => handleRegister(event)} href='.' >Registrar</a>
        </form>
      </div>
    </>
  );
}
